import {
	getRelativeInfo,
	getAlibabaSkuInfo,
	postRelativeSave,
	getRelativeQuery,
	getRelativeHistory,
	postImageSearch,
	getFilterTypes,
	postSyncWxProduct,
} from "../../../api/wxshop/relative.js";

let modules = {
	namespaced: true,
	state: {},
	mutations: {},
	actions: {
		getRelativeInfoAction(conText, payload) {
			getRelativeInfo(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
		getAlibabaSkuInfoAction(conText, payload) {
			getAlibabaSkuInfo(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
		postRelativeSaveAction(conText, payload) {
			postRelativeSave(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
		getRelativeQueryAction(conText, payload) {
			getRelativeQuery(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
		getRelativeHistoryAction(conText, payload) {
			getRelativeHistory(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
		imageSearchAction(conText, payload) {
			postImageSearch(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
		filterTypesAction(conText, payload) {
			getFilterTypes(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
		syncWxProductAction(conText, payload) {
			postSyncWxProduct(payload.data || {}).then(res => {
				if (payload.success) payload.success(res)
			}).catch(err => {
				if (payload.error) payload.error(err)
			})
		},
	}
}

export default modules;
